import React, { Component } from "react"
import { Input, Div, Label } from "@driftt/tide-core"
import { InlineSelect } from "@driftt/dds"
import { equals } from "ramda"
import { OPERATOR_LABELS_BY_TYPE } from "components/ContactFilterBuilder/constants/Operators"

export const DROPDOWN_VALUE = {
  FIRST: false,
  LAST: true
}

export const DATE_OPERATOR_TYPES = ['IS_BEFORE', 'IS_AFTER', 'IS_BEFORE_RELATIVE', 'IS_AFTER_RELATIVE']

class OperatorLabel extends Component {
  constructor(props) {
    super(props)
    this.state = {
      segmentValue: DROPDOWN_VALUE.FIRST
    }
  }

  onChange = (segmentValue) => {
    this.setState({
      segmentValue: segmentValue
    })
    this.props.setValue(segmentValue)
  }

  renderDropDown = operator => {
    if (DATE_OPERATOR_TYPES.includes(operator) && this.props.currentEntityType === 'events') {
      return (
        <Div
          className="filter-builder--operator-select-label-dropdown"
          id={operator}
        >
          <InlineSelect
            for={operator}
            placeholder={"First"}
            value={this.state.segmentValue}
            onValueChange={this.onChange}
            options={[
              {
                label: "First",
                value: false
              },
              {
                label: "Last",
                value: true
              }
            ]}
          />
        </Div>
      )
    }
  }

  render() {
    const {
      operator,
      activeOperator,
      updateActiveOperator,
      currentEntityType,
    } = this.props
    return (
      <Div className="filter-builder--operator-select-input">
        <Input
          type="radio"
          id={operator}
          checked={equals(operator, activeOperator)}
          value={operator}
          name="operator-selection"
          onChange={updateActiveOperator}
        />
        {this.renderDropDown(operator)}
        <Label htmlFor={operator}>
          {OPERATOR_LABELS_BY_TYPE[currentEntityType][operator]}
        </Label>
      </Div>
    )
  }
}

export default OperatorLabel
